import { render } from "./AddGoalModal.vue?vue&type=template&id=5b44d865&scoped=true"
import script from "./AddGoalModal.vue?vue&type=script&lang=js"
export * from "./AddGoalModal.vue?vue&type=script&lang=js"

import "./AddGoalModal.vue?vue&type=style&index=0&id=5b44d865&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b44d865"]])

export default __exports__